module.exports = __webpack_public_path__ + "img/success.29ae5837.png";